import React from 'react';

interface Props {
  label: string;
}

const OverlaySectionHeavyLabel: React.FC<Props> = ({ label }: Props) => {
  return <div className="font-size-5 medium black-2 mb2">{label}</div>;
};

export default OverlaySectionHeavyLabel;
